(ns css.icons
  (:require
    [css.core :as css
     :refer [get-theme embed-svg]]))


(defn- format-svg
  "Intercept the given pre-parsed hiccup (parsed at compile time) and provide our
  own overriding styles at runtime. This is super dangerous. We will also have to
  evolve this fn to walk the inner SVG an look for fills, strokes, etc. if we want
  to later override those styles too. Right now it's only operating on the top level
  SVG element (mainly for width/height/viewBox)."
  ([hiccup styles]
   (update hiccup
           1
           (fn [old] (merge (dissoc old :viewbox)
                            {:viewBox (get old :viewbox)}
                            styles)))))

(defn tools
  ([] (tools {}))
  ([args] (format-svg (embed-svg "tools") args)))

(defn dashboard
  ([] (dashboard {}))
  ([args] (format-svg (embed-svg "dashboard") args)))

(defn pencil
  ([] (pencil {}))
  ([args] (format-svg (embed-svg "pencil") args)))

(defn chart
  ([] (chart {}))
  ([args] (format-svg (embed-svg "chart") args)))

(defn chart-white
  ([] (chart-white {}))
  ([args] (format-svg (embed-svg "chart-white") args)))

(defn magnifier
  ([] (magnifier {}))
  ([args] (format-svg (embed-svg "magnifier") args)))

(defn chevron
  ([] (chevron {}))
  ([args] (format-svg (embed-svg "chevron") args)))

(defn hamburger
  ([] (hamburger {}))
  ([args] (format-svg (embed-svg "hamburger") args)))

(defn calendar
  ([] (calendar {}))
  ([args] (format-svg (embed-svg "calendar") args)))

(defn user
  ([] (user {}))
  ([args] (format-svg (embed-svg "user") args)))

(defn accounts
  ([] (accounts {}))
  ([args] (format-svg (embed-svg "accounts") args)))

(defn link
  ([] (link {}))
  ([args] (format-svg (embed-svg "link") args)))

(defn close
  ([] (close {}))
  ([args] (format-svg (embed-svg "close") args)))

(defn very-dissatisfied
  ([] (very-dissatisfied {:width "30px" :height "30px"}))
  ([args] (format-svg (embed-svg "very-dissatisfied") args)))

(defn dissatisfied
  ([] (dissatisfied {:width "30px" :height "30px"}))
  ([args] (format-svg (embed-svg "dissatisfied") args)))

(defn neutral
  ([] (neutral {:width "30px" :height "30px"}))
  ([args] (format-svg (embed-svg "neutral") args)))

(defn satisfied
  ([] (satisfied {:width "30px" :height "30px"}))
  ([args] (format-svg (embed-svg "satisfied") args)))

(defn very-satisfied
  ([] (very-satisfied {:width "30px" :height "30px"}))
  ([args] (format-svg (embed-svg "very-satisfied") args)))

(defn email
  ([] (email {:width "20px" :height "20px"}))
  ([args] (format-svg (embed-svg "email") args)))

(defn plus
  ([] (plus {:width "20px" :height "20px"}))
  ([args] (format-svg (embed-svg "plus") args)))

(defn error
  ([] (error {:width "60px" :height "60px"}))
  ([args] (format-svg (embed-svg "error") args)))

(defn eyecon
  ([] (eyecon {:width "20px" :height "20px"}))
  ([args] (format-svg (embed-svg "eyecon") args)))

(defn menu
  ([] (menu {:stroke "#000"}))
  ;; this is beautiful, svg is so fun
  ([args] (format-svg
            (update
              (embed-svg "menu")
              ;; 2nd index is the the [:path]
              2
              ;; 1st index is the properties of [:path]
              #(update % 1 assoc :stroke (:stroke args)))
            (dissoc args :stroke))))

(defn feeling-icon [feeling]
  (condp = feeling
    "VERY_DISSATISFIED" [very-dissatisfied]
    "DISSATISFIED" [dissatisfied]
    "NEUTRAL" [neutral]
    "SATISFIED" [satisfied]
    "VERY_SATISFIED" [very-satisfied]
    [neutral]))
